(function initProductDrops() {
  const drops = window.__PRODUCT_DROPS__;
  if (!drops) return;

  const atcContainer = document.querySelector('.add-to-cart-container');
  const bisPlaceholder = document.getElementById('klaviyo-bis-placeholder');

  if (!atcContainer || !bisPlaceholder) return;

  function isDropVariant(variantId) {
    const variant = drops.variants[String(variantId)];
    if (!variant) return false;
    if (!variant.isEnabled) return false;
    if (!variant.dropDate) return false;

    // Drop is in the future
    return variant.dropDate > drops.now;
  }

  function updateUI(variant) {
    if (!variant) return;

    const variantId = String(variant.id);
    const isDrop = isDropVariant(variantId);
    const isSoldOut = !variant.available;

    if (isDrop || isSoldOut) {
      atcContainer.style.display = 'none';
      bisPlaceholder.removeAttribute('hidden');
    } else {
      atcContainer.style.display = '';
      bisPlaceholder.setAttribute('hidden', '');
    }
  }

  // Initial render (best-effort)
  if (window.Shopify?.product?.variants) {
    const initial = window.Shopify.product.variants.find(
      v => String(v.id) === String(drops.initialVariantId)
    );
    updateUI(initial);
  }

  // Variant changes (Dawn / OS2 compatible)
  document.addEventListener('theme:variant:change', (e) => {
    updateUI(e.detail?.variant);
  });
})();